import { forwardRef } from 'react';

import type { IconProps } from './types';

export const ButtonPlay = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <g clipPath="url(#clip0_637_3430)">
      <path
        d="M10 20.6187C11.9778 20.6187 13.9112 20.0322 15.5557 18.9333C17.2002 17.8345 18.4819 16.2727 19.2388 14.4455C19.9957 12.6182 20.1937 10.6076 19.8078 8.66775C19.422 6.72794 18.4696 4.94611 17.0711 3.54759C15.6725 2.14906 13.8907 1.19666 11.9509 0.810804C10.0111 0.424952 8.00043 0.622985 6.17316 1.37986C4.3459 2.13674 2.78412 3.41846 1.6853 5.06295C0.58649 6.70744 0 8.64084 0 10.6187C0.00286757 13.2699 1.05736 15.8118 2.9321 17.6866C4.80684 19.5613 7.34871 20.6158 10 20.6187ZM14.01 11.0353C14.0025 11.1845 13.9525 11.3285 13.8658 11.4502C13.7791 11.5718 13.6594 11.6662 13.5208 11.722L8.45 14.257C8.31317 14.328 8.16163 14.3659 8.0075 14.3678C7.864 14.3689 7.72309 14.3296 7.60083 14.2545C7.47676 14.1719 7.37628 14.0586 7.30922 13.9255C7.24217 13.7924 7.21085 13.6442 7.21833 13.4953V8.57365C7.2056 8.42418 7.23454 8.2741 7.30194 8.14008C7.36935 8.00605 7.47257 7.89333 7.60017 7.81443C7.72776 7.73553 7.87472 7.69353 8.02474 7.6931C8.17475 7.69267 8.32196 7.73382 8.45 7.81199L13.5208 10.3478C13.6595 10.4037 13.7793 10.4981 13.866 10.62C13.9527 10.7418 14.0027 10.886 14.01 11.0353Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_637_3430">
        <rect width="20" height="20" fill="white" transform="translate(0 0.618652)" />
      </clipPath>
    </defs>
  </svg>
));

export default ButtonPlay;
